import { render } from "./FormFile.vue?vue&type=template&id=0a7e62a8&scoped=true"
import script from "./FormFile.vue?vue&type=script&lang=js"
export * from "./FormFile.vue?vue&type=script&lang=js"

import "./FormFile.vue?vue&type=style&index=0&id=0a7e62a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7e62a8"]])

export default __exports__